import { createGlobalStyle } from "styled-components";
import globalStyles from "./theme.json";

const { colors } = globalStyles;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${colors.primary.offWhite};
    color: ${colors.primary.green};
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    line-height: 1.5;
    overflow-x: hidden;
    max-width: 1440px;
    margin: 0 auto;

    h1 {
      font-family: "Roboto", sans-serif;
      font-size: 2rem;
      line-height: 1.2;
      font-weight: 700;
      color: ${colors.primary.black};
    }

    h2 {
      font-family: "Roboto", sans-serif;
      font-size: 1.5rem;
      line-height: 1.3;
      font-weight: 700;
      color: ${colors.primary.black};
    }

    h3 {
      font-family: "Roboto", sans-serif;
      font-size: 1.3rem;
      line-height: 1.3;
      font-weight: 700;
      color: ${colors.primary.black};
    }

    p {
      font-family: "Open Sans", sans-serif;
      font-size: 1.125rem;
      line-height: 1.7;
      font-weight: 400;
    }

    li {
      font-family: "Open Sans", sans-serif;
      font-size: 1.125rem;
      line-height: 1.6;
      font-weight: 400;
    }
  }
  
  html {}
`;

export default GlobalStyle;
